/* unplugin-vue-components disabled */import { render } from "./OpenQuestionChapterView.vue?vue&type=template&id=308829c4&scoped=true&ts=true"
import script from "./OpenQuestionChapterView.vue?vue&type=script&lang=ts"
export * from "./OpenQuestionChapterView.vue?vue&type=script&lang=ts"

import "./OpenQuestionChapterView.vue?vue&type=style&index=0&id=308829c4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308829c4"]])

export default __exports__